import { createFileRoute, redirect } from '@tanstack/react-router';

/* /admin has no page of its own — the first tool is the landing page. */
export const Route = createFileRoute('/_app/admin/')({
  staticData: { orgScope: 'none' },
  beforeLoad: () => {
    throw redirect({ to: '/admin/scheduled-tasks' });
  },
});
